import { SubpageIntro2018, SubpageLayout2018 } from '../subpageLayout';

type Winner = { company: string; award: string };
type WinnerCategory = {
  key: 'mobility' | 'living' | 'environment' | 'people' | 'government' | 'economy';
  title: string;
  tab: string;
  icon: string;
  winners: Winner[];
};

const categories: WinnerCategory[] = [
  {
    key: 'mobility',
    title: '香港智慧城市大獎2018 - 智慧出行',
    tab: '香港智慧城市大獎2018- 智慧出行',
    icon: '/2018/images/mobility.png',
    winners: [
      { company: '香港機場管理局', award: '傑出國際機場流動應用程式' },
      { company: '報貝有限公司', award: '傑出商務移動支付平台' },
      { company: '綠色安全科技有限公司', award: '傑出雲端車隊管理系統' },
      { company: '香港應用科技研究院有限公司', award: '傑出車聯網管理系統' },
      { company: 'Hong Kong Electric Vehicle Network Limited', award: '傑出手提式電動車充電器' },
      { company: '英飛凌科技香港有限公司', award: '傑出智能路燈系統' },
      { company: '硬蛋科技(香港)有限公司', award: '傑出智能駕駛輔助系統' },
      { company: '物流及供應鏈多元技術研發中心', award: '傑出差分全球定位系統' },
      { company: '日本電氣香港有限公司', award: '傑出智能交通管理方案' },
      { company: '即充能源有限公司', award: '傑出智能電動車充電系統' },
      { company: '思路富邦智能應用有限公司', award: '傑出智能零售整合顧客數據推廣方案' },
      { company: 'Smart Charge 「全線充」', award: '傑出一站式電動車充電方案' },
      { company: '華飛思科技有限公司', award: '傑出智能識別追蹤系統' },
    ],
  },
  {
    key: 'living',
    title: '香港智慧城市大獎2018 - 智慧生活',
    tab: '香港智慧城市大獎2018- 智慧生活',
    icon: '/2018/images/living.png',
    winners: [
      { company: 'AXA安盛', award: '傑出保險科技創新 (客戶體驗)' },
      { company: '中國移動香港有限公司', award: '傑出粵港澳大灣區流動網絡供應商' },
      { company: '金寶通集團有限公司', award: '傑出智能溫控物聯網解決方案' },
      { company: '隨行醫生', award: '傑出人工智慧醫療服務聊天機械平台' },
      { company: '創龍企業解決方案有限公司', award: '傑出AR智能眼鏡技術' },
      { company: '康訊生物分析有限公司', award: '傑出評估健康之數據分析方案' },
      { company: 'HKT Payment Limited (Tap & Go)', award: '傑出流動支付手機應用程式' },
      { company: 'HKT Smart Living', award: '傑出智能家居方案' },
      { company: '醫院管理局', award: '傑出臨床管理系統' },
      { company: '易寶時有限公司', award: '傑出離線手機預付系統' },
      { company: '物流及供應鏈多元技術研發中心', award: '傑出RFID視障人士手杖系統' },
      { company: '日本電氣香港有限公司', award: '傑出智慧生活為本方案' },
      { company: '寶利數碼有限公司', award: '傑出網絡安全認證系統' },
      { company: '善覓有限公司', award: '傑出癌症基因液體活檢技術' },
    ],
  },
  {
    key: 'environment',
    title: '香港智慧城市大獎2018 - 智慧環境',
    tab: '香港智慧城市大獎2018- 智慧環境',
    icon: '/2018/images/environment.png',
    winners: [
      { company: '碳世界有限公司', award: '傑出能源網貨幣轉換平台' },
      { company: '鷹眼系統有限公司', award: '傑出滑波監測系統' },
      { company: '香港應用科技研究院有限公司', award: '傑出水務物聯網系統' },
      { company: '三立科技企業有限公司', award: '傑出智能廢物管理系統' },
      { company: '物流及供應鏈多元技術研發中心', award: '傑出差分全球導航衛星系統' },
    ],
  },
  {
    key: 'people',
    title: '香港智慧城市大獎2018 - 智慧市民',
    tab: '香港智慧城市大獎2018- 智慧市民',
    icon: '/2018/images/people.png',
    winners: [
      { company: '有光集團有限公司', award: '傑出人工智慧服務員系統' },
      { company: '富成人工智能有限公司', award: '傑出人工智能學習應用程式' },
      { company: '鍵傳金融科技有限公司', award: '傑出智慧租金支付平台' },
      { company: '日本電氣香港有限公司', award: '傑出面部識別方案' },
      { company: '聖保祿學校', award: '傑出STEM教育學校' },
    ],
  },
  {
    key: 'government',
    title: '香港智慧城市大獎2018 - 智慧政府',
    tab: '香港智慧城市大獎2018- 智慧政府',
    icon: '/2018/images/government.png',
    winners: [
      { company: '區塊鏈科研有限公司', award: '傑出區塊鏈創新科技方案' },
      { company: '啟榮電子軟件開發有限公司', award: '傑出物聯網智慧路燈管理系統' },
      { company: '物流及供應鏈多元技術研發中心', award: '傑出智能渠道管理系統' },
      { company: '日本電氣香港有限公司', award: '傑出影像分析方案' },
    ],
  },
  {
    key: 'economy',
    title: '香港智慧城市大獎2018 - 智慧經濟',
    tab: '香港智慧城市大獎2018- 智慧經濟',
    icon: '/2018/images/economy.png',
    winners: [
      { company: '空搜網', award: '傑出機票價格網上比較平台' },
      { company: 'Animae Technologies Limited', award: '傑出智慧電子印章應用程式' },
      { company: '聯款通', award: '傑出網上支付平台' },
      { company: '佳能香港有限公司', award: '傑出雲端及流動工作平台' },
      { company: '大新銀行有限公司', award: '傑出中小企網上虛擬銀行服務中心' },
      { company: 'DHL Express 香港', award: '傑出網上自選遞送服務' },
      { company: '樓盤王', award: '傑出房地產資訊流動應用程式' },
      { company: 'Eatigo Hong Kong Limited', award: '傑出網上餐廳訂座平台' },
      { company: 'Eats365 Hong Kong Limited', award: '傑出雲端餐飲管理平台' },
      { company: '俊盟國際有限公司', award: '傑出電子支付方案' },
      { company: '香港應用科技研究院有限公司', award: '傑出移動設備文字糾錯系統' },
      { company: 'JOS', award: '傑出智慧零售方案' },
      { company: '物流及供應鏈多元技術研發中心', award: '傑出自動跟隨機械人技術' },
      { company: 'OpenVR.shop - Wee Creation Company Limited', award: '傑出虛擬實境電商平台' },
      { company: '利嘉閣地產有限公司', award: '傑出人工智能物業平台' },
      { company: '今之通訊有限公司', award: '傑出多媒體通訊協作方案' },
      { company: '日日通', award: '傑出科技保險科研及應用平台' },
    ],
  },
];

export default function Winners2018Zh() {
  return (
    <SubpageLayout2018 lang="zh" title="得獎名單" page="winners">
      <div className="award_categories">
        <SubpageIntro2018 heading="得獎名單" />
        <div className="winners_list_wrapper">
          <div className="winners_list_container">
            <div className="col-left">
              <div className="winners_cate_nav" id="winners_cate_nav">
                <ul className="tabs">
                  {categories.map((c, idx) => (
                    <li key={c.key} className={`anchorlink nav_${c.key}${idx === 0 ? ' current_mobility' : ''}`} id={`winner_${c.key}`}>
                      <a className={idx === 0 ? 'color' : undefined} href={`#company_list_${c.key}`}>
                        <img src={c.icon} alt="" />
                        <div className="tabs_text">
                          香港智慧城市大獎2018-
                          <br />
                          {c.title.split(' - ')[1]}
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-right">
              <div className="company_list_container">
                <div className="company_list">
                  {categories.map((c) => (
                    <div key={c.key} id={`company_list_${c.key}`} className={`company_list_${c.key} target`}>
                      <ul className="companies">
                        <li className="award_title">{c.title}</li>
                        <br />
                        {c.winners.map((w) => (
                          <div key={`${c.key}-${w.company}`}>
                            <li className="award_company_name">{w.company}</li>
                            <li className="award_name">{w.award}</li>
                            <br />
                          </div>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

